module.exports = __webpack_public_path__ + "static/Aston-20193_bdcdxu-ae84a2d642a4573a0d68f2fa9ea5792e.jpg";